<template>
  <section>
  <v-speed-dial
  id="speed"
  x-large
  elevation="9"
  v-model="fab"
  :top="true"
  :right="true"
  :direction="'left'"
  :open-on-hover="true"
  :transition="'slide-y-reverse-transition'"
  >
  <template v-slot:activator>
    <v-btn
    v-model="fab"
    color="red accent-4"
    dark
    fab
    >
    <v-icon v-if="fab">
      mdi-close
    </v-icon>
    <v-icon v-else>
      mdi-check
    </v-icon>
  </v-btn>
</template>
<v-btn
fab
dark
small
color="indigo accent-1"
@click="imprimir"
>
<v-icon>mdi-printer</v-icon>
</v-btn>     
</v-speed-dial>
<v-row>
  <v-col cols="5" id="creador" :class="{'noMostrar' : listoImprimir}" class="col-lg-5 col-12">
    <v-stepper
    v-model="e6"
    vertical
    >
    <v-stepper-step step="1" :complete="e6 > 1" non-linear editable>
      Configurar
    </v-stepper-step>
    <v-stepper-content step="1">
      <v-card
      class="mb-2 pa-10"
      >
      <configuracion-component @fuente="cambiarTamanioFuente" @color="cambiarColor" @familia="cambiarFamiliaFuente"/>
    </v-card>
    <v-btn
    color="primary"
    @click="e6 = 2"
    >
    Continuar
  </v-btn>

</v-stepper-content>

<v-stepper-step
:complete="e6 > 2"
step="2"
non-linear
editable
>
Información personal  
<small>Escribe quién eres</small>
</v-stepper-step>

<v-stepper-content step="2">
  <v-card
  class="mb-2"
  >
  <informacion-personal @informacion="obtenerInformacionPersonal"/>
</v-card>
<v-btn
color="primary"
@click="e6 = 3"
>
Continuar
</v-btn>
<v-btn text @click="e6 -= 1">
  Regresar
</v-btn>
</v-stepper-content>

<v-stepper-step
:complete="e6 > 3"
step="3"
non-linear 
editable
>
Datos de contacto
</v-stepper-step>

<v-stepper-content step="3">
  <v-card
  class="mb-2"
  >
  <datos-contacto @contacto="obtenerDatosContacto"/>
</v-card>
<v-btn
color="primary"
@click="e6 = 4"
>
Continuar
</v-btn>
<v-btn text @click="e6 -= 1">
  Regresar
</v-btn>
</v-stepper-content>

<v-stepper-step
:complete="e6 > 4"
step="4"
non-linear 
editable
>
Educación
</v-stepper-step>

<v-stepper-content step="4">
  <v-card
  class="mb-2"
  >
  <datos-educacion @escuela="agregarEscuela"/>
</v-card>
<v-btn
color="primary"
@click="e6 = 5"
>
Continuar
</v-btn>
<v-btn text  @click="e6 -= 1">
  Regresar
</v-btn>
</v-stepper-content>

<v-stepper-step
:complete="e6 > 5"
step="5"
non-linear 
editable
>
Experiencia laboral
</v-stepper-step>

<v-stepper-content step="5">
  <v-card
  class="mb-2"
  >
  <experiencia-laboral @empleo="agregarEmpleo"/>
</v-card>
<v-btn
color="primary"
@click="e6 = 6"
>
Continuar
</v-btn>
<v-btn text  @click="e6 -= 1">
  Regresar
</v-btn>
</v-stepper-content>

<v-stepper-step step="6" :complete="e6 > 6" non-linear editable>
  Hábilidades
</v-stepper-step>
<v-stepper-content step="6">
  <v-card
  class="mb-2"
  >
  <habilidades-component @habilidad="agregarHabilidad"/>
</v-card>
<v-btn
color="primary"
@click="e6 = 7"
>
Continuar
</v-btn>
<v-btn text @click="e6 -= 1">
  Regresar
</v-btn>
</v-stepper-content>


<v-stepper-step step="7" :complete="e6 > 7" non-linear editable>
  Idiomas
</v-stepper-step>
<v-stepper-content step="7">
  <v-card
  class="mb-2"
  >
  <idiomas-component @idioma="agregarIdioma"/>
</v-card>
<v-btn
color="primary"
@click="e6 = 8"
>
Continuar
</v-btn>
<v-btn text @click="e6 -= 1">
  Regresar
</v-btn>
</v-stepper-content>

<v-stepper-step step="8" :complete="e6 > 8" non-linear editable>
  Pasatiempos
</v-stepper-step>
<v-stepper-content step="8">
  <v-card
  class="mb-2"
  >
  <pasa-tiempos @pasatiempos="agregarPasatiempos"/>
</v-card>
<v-btn
color="primary"
@click="e6 = 9"
>
Continuar
</v-btn>
<v-btn text @click="e6 -= 1">
  Regresar
</v-btn>
</v-stepper-content>

<v-stepper-step step="9" :complete="e6 > 9" non-linear editable>
  Fotografía
</v-stepper-step>
<v-stepper-content step="9">
  <v-card
  class="mb-2"
  >
  <seleccionar-foto @imagen="seleccionarFoto"/>
</v-card>
<v-btn
color="primary"
@click="e6 = 1"
>
Continuar
</v-btn>
<v-btn text @click="e6 -= 1">
  Regresar
</v-btn>
</v-stepper-content>


</v-stepper>
</v-col>
<v-col>
  <div id="cv">
    <plantilla-cv 
    :informacion="informacionPersonal"
    :contacto="datosContacto"
    :escuelas="escuelasAgregadas"
    :empleos="empleosAgregados"
    :habilidades="habilidadesAgregadas"
    :idiomas="idiomasAgregados"
    :pasatiempos="pasatiemposAgregados"
    :foto="imagen"
    :color="colores"
    :tamanio="tamanioFuente"
    :familia="familiaFuente"/>
  </div>

</v-col>
</v-row>

</section>
</template>
<script>
  import InformacionPersonal from './InformacionPersonal'
  import DatosContacto from './DatosContacto'
  import DatosEducacion from './DatosEducacion'
  import ExperienciaLaboral from './ExperienciaLaboral'
  import HabilidadesComponent from './HabilidadesComponent'
  import IdiomasComponent from './IdiomasComponent'
  import PasaTiempos from './PasaTiempos'
  import SeleccionarFoto from './SeleccionarFoto'
  import ConfiguracionComponent from './ConfiguracionComponent'
  import PlantillaCv from './PlantillaCv'
  export default {
    name: "CrearCurriculum",
    components: {
      InformacionPersonal,
      DatosContacto,
      DatosEducacion,
      ExperienciaLaboral,
      HabilidadesComponent,
      IdiomasComponent,
      PasaTiempos,
      SeleccionarFoto,
      ConfiguracionComponent,
      PlantillaCv
    },

    data () {
      return {
        fab: false,
        e6: 1,
        escuelasAgregadas: [],
        empleosAgregados: [],
        habilidadesAgregadas: [],
        idiomasAgregados: [],
        pasatiemposAgregados: "",
        imagen: null,
        tamanioFuente: 15,
        familiaFuente:"Roboto",
        colores: {
          primario: "#3F51B5",
          secundario: "#2196F3",
          terciario: "#BBDEFB",
          texto: "#FFFFFF"
        },
        listoImprimir: false,
        informacionPersonal: {
          nombre: "PacoHunterDev",
          estudios: "Licenciado",
          edad: "25",
          estadoCivil: "Soltero",
          descripcion: "Aquí poner la descripción"
        },
        datosContacto: {
          telefono: "7776661234",
          email: "correo@mail.components",
          web: "TuSitioWeb.com",
          youtube: "TuCanalDeYutu",
          github: "tuGitHub.com"
        }
      }
    },

    beforeMount() {
       window.addEventListener("beforeunload", this.preventNav)
       this.$once("hook:beforeDestroy", () => {
         window.removeEventListener("beforeunload", this.preventNav);
       })
     },

     beforeRouteLeave(to, from, next) {
       if (this.escuelasAgregadas.length > 0 || this.empleosAgregados.length > 0 || this.idiomasAgregados.length > 0) {
         if (!window.confirm("Al navegar a otra ruta perderás lo datos agregados, Continuar?")) {
           return;
         }
       }
       next();
     },

    methods: {
       preventNav(event) {
         if (this.escuelasAgregadas.length > 0 || this.empleosAgregados.length > 0 || this.idiomasAgregados.length > 0) return
         event.preventDefault()
         event.returnValue = ""
       },

      obtenerInformacionPersonal(informacion){
        this.informacionPersonal = informacion
      },

      obtenerDatosContacto(datos){
        this.datosContacto = datos
      },

      agregarEscuela(escuelas){
        this.escuelasAgregadas = escuelas
      },

      agregarEmpleo(empleos){
        this.empleosAgregados = empleos
      },

      agregarHabilidad(habilidades){
        this.habilidadesAgregadas = habilidades
      },

      agregarIdioma(idiomas){
        this.idiomasAgregados = idiomas
      },

      agregarPasatiempos(pasatiempos){
        this.pasatiemposAgregados = pasatiempos
      },

      seleccionarFoto(foto){
        this.imagen = foto
      },

      cambiarTamanioFuente(numero){
        this.tamanioFuente = numero
      },

      cambiarFamiliaFuente(familia){
        this.familiaFuente = familia
      },

      cambiarColor(datos){
        switch(datos.tipo){
          case 'Primario':
          this.colores.primario = datos.color
          break

          case 'Secundario':
          this.colores.secundario = datos.color
          break

          case 'Terciario':
          this.colores.terciario = datos.color
          break

          case 'Texto':
          this.colores.texto = datos.color
          break

          default:
          console.log("Colores por defecto")

        }
      },

      imprimir(){
        this.listoImprimir = true
        window.print()
      }
    }
  }
</script>
<style >
@media print {
  body {-webkit-print-color-adjust: exact;}
  .noMostrar{
   display: none; 
 }

 #creador, #tabs, #speed * { 
  display: none; 
} 
#cv, #cv * { 
  visibility: visible; ; 
}
}
.v-speed-dial {
  position: absolute;
}
</style>